module.exports = __webpack_public_path__ + "public/img/Bahasa Inggris untuk Karyawan.43c73753.png";